import { DateTime } from 'luxon';

export class RequestDocumentApi 
{
    creationDate: DateTime;
    documentId: string;
    documentNumber: number;
    documentName: string;
    physicalName: string;
    extension: string;
    mediaType: string;
    size: number;
}
